import React from 'react';
import OptionButton from '../shared/OptionButton';
import { DistanceUnit } from '../../../types/enums';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const DistanceUnitStep: React.FC<StepProps> = ({ answer, onAnswer }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <OptionButton label="Kilometres" value={DistanceUnit.KM} selected={answer === DistanceUnit.KM} onClick={onAnswer} />
      <OptionButton label="Miles" value={DistanceUnit.MILE} selected={answer === DistanceUnit.MILE} onClick={onAnswer} />
    </div>
  );
};

export default DistanceUnitStep;
